<template>
  <el-dialog title="切换部门" :visible.sync="showModal" width="50%" append-to-body :before-close="handleClose">
    <el-card :gutter="20">
      <el-row :gutter="20">
        <el-col :span="3">
          <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" size="mini">同步部门信息</el-button>
        </el-col>
        <el-col :md="8" :lg="4">
            <el-select size="small" v-model="params.corp_id" clearable placeholder="切换企业"  @change="typesearch">
                <el-option v-for="item in corpList" :key="item.id" :label="item.title" size="mini" :value="item.id"> </el-option>
            </el-select>
        </el-col>
      </el-row>
      <!--tree-->
      <el-tree
              :props="defaultProps"
              :data="data"
              node-key="id"
              :default-expand-all="false"
              :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }" @click="clickTree(data)">
        <span>{{ node.label }}</span>
      </span>
      </el-tree>
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
    import {getWorkDep,getSnyDep,getCropList,syncDepartment} from '../../../api/workwx'
    export default {
        props: {
          // data: [Object, Array],
          multiple: {
            type: Boolean,
            default: false
          },
          visible: {
            type: Boolean,
            default: false
          }
        },
        name: "Category",
        data() {
            return {
                data: [],
                defaultProps: {
                    label: 'name'
                },
                showModal: false,
                loading: false,
                current: [],
                checked: '',
                name:'',
                params:{},
                corpList:[],
            }
        },
        created() {
            this.getWorkDep();
            this.getCropList();
        },
        watch: {
          data (val) {
            if (val.id) {
              this.checked = val
            } else {
              this.checked = ''
            }
          },
          visible (val) {
            if (val) {
              this.showModal = true
            }
          }
        },
        methods: {
            // 组件化
            handleConfirm () {
              this.$emit('change', this.current)
              this.showModal = false
            },
            handleClose () {
              this.showModal = false
              this.$emit('onClose')
            },
            // 获取部门列表
            getWorkDep() {
              getWorkDep(this.params).then(res => {
                  this.data = this.arraytotree(res.data.data);
                  this.loading = false
              })
            },
            // 获取企业列表
            getCropList(){
              getCropList(this.params).then(res => {
                this.corpList = res.data.data.list
                })
            },
            typesearch (id) {
               let obj = {}
               obj = this.corpList.find(item => {
                 return item.id === id
               });
              this.current.cropname = obj.title
              this.current.corp_id = this.params.corp_id
              this.params.page = 1
              this.getWorkDep(this.params)
            },
            // 同步企业列表
            addTemplate () { // 添加商品
              if(this.params.corp_id==undefined || this.params.corp_id==null){
                this.$message({
                  type: 'error',
                  message: '请选择企业'
                })
              }
              getSnyDep({'corp_id':this.params.corp_id}).then(res=>{
                this.$message({
                  type: 'success',
                  message: '同步成功'
                })
              })
            },
            handleNodeClick(data) {
            },
            clickTree(data){
              this.current = data

              // 根据id获取成员信息
              // console.log(id)
            },
            //数组转化为树
            arraytotree(arr) {
                var top = [], sub = [], tempObj = {};

                arr.forEach(function (item) {
                  // console.log(item)
                    if (item.parent_id === 0) { // 顶级分类
                        top.push(item)

                    } else {
                        sub.push(item) // 其他分类
                    }
                    item.children = []; // 默然添加children属性
                    tempObj[item.wx_department_id] = item // 用当前分类的id做key，存储在tempObj中
                })

                sub.forEach(function (item) {
                    // 取父级
                    var parent = tempObj[item.parent_id] || {'children': []}
                    // 把当前分类加入到父级的children中
                    parent.children.push(item)
                })
                return top
            },
        },

    }
</script>
<style  scoped lang="scss">
.is-current span {
  color: #1480e3;
}
</style>



// WEBPACK FOOTER //
// depTree.vue?2f149509